import React, { useRef } from 'react';
import Picker from 'react-datepicker';
import { toDate, toTime, calculatePIStartDate } from 'helpers';

function DateTimePicker({
  tabIndex, value, hideTime, onChange, name, defaultMin = 0, isClearable = true, ...rest
}) {
  const uniqueClassName = `datefield-${name}`;

  const ref = useRef();

  const onChangeDate = (date) => {
    onChange(date != null ? calculatePIStartDate(date, defaultMin) : null);
  };

  const date = toDate(value);
  const time = value ? toTime(value) : '';
  const field = (
    <Picker
      {...rest}
      onChange={onChangeDate}
      selected={date}
      ref={ref}
      tabIndex={tabIndex}
      showYearDropdown
      isClearable={isClearable}
      dateFormat="dd-MMM-yyyy"
      className={`reactSelect-wrapper ${uniqueClassName}`}
      popperPlacement="top"
    />
  );

  return !hideTime ? (
    <div className="row">
      <div className="col-6 pr-1">{field}</div>
      <div className="col-6 pl-1">
        <input className="form-control" disabled value={time} />
      </div>
    </div>
  ) : (
    field
  );
}

export default DateTimePicker;
